var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBranding = function SvgBranding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Group 464",
    viewBox: "0 0 50.134 46"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "branding_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h50.134v46H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#branding_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.239 20.999a2.255 2.255 0 0 0-2.255 2.255 18.12 18.12 0 0 1-5.341 12.9 2.255 2.255 0 0 0 3.188 3.188 22.6 22.6 0 0 0 6.667-16.088 2.255 2.255 0 0 0-2.255-2.255M30.1 39.945A18.241 18.241 0 0 1 12.552 8.129a18.14 18.14 0 0 1 10.195-3.113 2.255 2.255 0 1 0 0-4.51 22.747 22.747 0 0 0 0 45.494 22.6 22.6 0 0 0 9.177-1.927 2.257 2.257 0 0 0-1.824-4.128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.473.66a2.253 2.253 0 0 0-3.188 0L21.758 25.191l-8.315-8.314a2.255 2.255 0 1 0-3.188 3.188l9.903 9.909a2.255 2.255 0 0 0 3.188 0L49.473 3.849a2.253 2.253 0 0 0 0-3.188"
  }))));
};
export default SvgBranding;